import React, {useEffect} from 'react';
import PropTypes from "prop-types";
import { useDispatch } from "react-redux";
import { closeDrawer } from "../../actions/drawerActions";
import ActionReviewHook from "../qd/actions/ActionReviewHook";
import ArgoAppBarHook from "../common/ArgoAppBarHook";
import ClickAwayListener from '@mui/material/ClickAwayListener';

const ActionReviewDrawerHook = (props) => {
    const { templateKey, templateId } = props;
    const dispatch = useDispatch();

    const handleCloseDrawer = () => {
        dispatch(closeDrawer());
    };

    useEffect(() => {
        const handleKeyDown = (e) => {
            if (e.key === "Escape") {
                e.preventDefault()
                handleCloseDrawer()
            }
        }

        document.addEventListener("keydown", handleKeyDown, true)

        return () => {document.removeEventListener("keydown", handleKeyDown, true)}
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <ClickAwayListener onClickAway={handleCloseDrawer}>
            <div>
                <ArgoAppBarHook
                    title="Review Action"
                    showMenuArrowButton="LEFT"
                    onLeftIconButtonTouchTap={handleCloseDrawer}
                    isDrawer={true}
                    width={actionReviewDrawerProps.width}
                />

                <div style={{height: '64px'}}></div>

                <div>
                    <ActionReviewHook templateKey={templateKey} templateId={templateId} width={actionReviewDrawerProps.width}/>
                </div>
            </div>
        </ClickAwayListener>
    );
};

ActionReviewDrawerHook.propTypes = {
    templateKey: PropTypes.string,
    templateId: PropTypes.string
};

const actionReviewDrawerProps = {
    opensecondary: true,
    width: "90%",
    docked: false,
    anchor: "right"
};

export default ActionReviewDrawerHook;
export { actionReviewDrawerProps };
